import { render, staticRenderFns } from "./fileViewer.vue?vue&type=template&id=c5c05306&scoped=true&"
import script from "./fileViewer.vue?vue&type=script&lang=js&"
export * from "./fileViewer.vue?vue&type=script&lang=js&"
import style0 from "./fileViewer.vue?vue&type=style&index=0&id=c5c05306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c05306",
  null
  
)

export default component.exports